import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation for current path tracking

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { alpha, styled } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';

// import { RouterLink } from 'src/routes/components';
import { Link as RouterLink } from 'react-router-dom';


import Iconify from '../../iconify';

// ----------------------------------------------------------------------

const NavItem = forwardRef(
  ({ title, path, icon, open, hasChild, externalLink, ...other }, ref) => {
    const location = useLocation();  // Get the current location
    const active = location.pathname === path;  
    const renderContent = (
      <StyledNavItem
      ref={ref}
      open={open}
      active={active}  // Pass the active state
      {...other}
      sx={{
        pb:3,
        '&:hover': {
          transform: 'scale(1.05)',
          '& .icon, & .label': {
            color: '#C6F760',
            fontWeight: 700,
          },
        },
      }}
    >
      {icon && (
        <Box component="span" className="icon" sx={{ color:'white',  fontWeight: 500, fontSize: '20px' }}>
          {icon}
        </Box>
      )}

      {title && (
        <Box component="span" className="label" sx={{ color:'white', fontWeight: 500, fontSize: '20px' }}>
          {title}
        </Box>
      )}

      {hasChild && <Iconify width={16} className="arrow" icon="eva:arrow-ios-forward-fill" />}
    </StyledNavItem>
    );

    if (externalLink) {
      return (
        <Link href={path} target="_blank" rel="noopener" underline="none" color="inherit">
          {renderContent}
        </Link>
      );
    }

    return (
      <Link component={RouterLink} to={path} underline="none" color="inherit">
        {renderContent}
      </Link>
    );
  }
);

NavItem.propTypes = {
  open: PropTypes.bool,
  path: PropTypes.string,
  icon: PropTypes.element,
  title: PropTypes.string,
  hasChild: PropTypes.bool,
  externalLink: PropTypes.bool,
};


export default NavItem;

// ----------------------------------------------------------------------

const StyledNavItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
  ...theme.typography.body2,
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(1.5),
  fontWeight: theme.typography.fontWeightMedium,
  '& .icon': {
    width: 20,
    height: 20,
    flexShrink: 0,
    marginRight: theme.spacing(2),
  },
  '& .label': {
    flexGrow: 1,
  },
  '& .arrow': {
    marginLeft: theme.spacing(0.75),
  },
  ...(active && {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    // backgroundColor:'red',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
    },
    '& .icon, & .label': {
            color: '#C6F760',
            fontWeight: 700,
          },
  }),
}));
